import type React from 'react';
import { CreateFolderModal } from 'shared-portal-components-v2';

import { useCreateFolderModal } from '@/hooks/createFolder/useCreateFolderModal';

export default function CreateFolderModalContainer(): React.JSX.Element | null {
  const { state, handlers } = useCreateFolderModal();

  if (!state.isOpen) return null;

  return (
    <CreateFolderModal
      open={state.isOpen}
      onOpenChange={handlers.handleOpenChange}
      folderName={state.folderName}
      isSubmitting={state.isSubmitting}
      onFolderNameChange={handlers.handleFolderNameChange}
      onCreate={handlers.handleCreate}
    />
  );
}
